"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHeader = void 0;

var _styles = require("./styles");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _StatusAsignationInfo = require("../StatusAsignationInfo");

var _variables = require("../../../global-files/variables");

var _jsxRuntime = require("react/jsx-runtime");

var TableHeader = function TableHeader(_ref) {
  var imagesStatus = _ref.imagesStatus,
      activeImage = _ref.activeImage,
      assignationsImages = _ref.assignationsImages,
      setAssignation = _ref.setAssignation,
      isRetailer = _ref.isRetailer,
      onClickSave = _ref.onClickSave,
      showSaveButton = _ref.showSaveButton,
      version = _ref.version,
      setShowVersionSelector = _ref.setShowVersionSelector;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      text: (activeImage === null || activeImage === void 0 ? void 0 : activeImage.name) || "-",
      color: _variables.GlobalColors.s5,
      headerType: "input-name-header"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_StatusAsignationInfo.StatusAsignationInfo, {
      status: imagesStatus,
      assignationsImages: assignationsImages,
      setAssignation: setAssignation,
      isRetailer: isRetailer,
      onClickSave: onClickSave,
      showSaveButton: showSaveButton,
      version: version,
      setShowVersionSelector: setShowVersionSelector
    })]
  });
};

exports.TableHeader = TableHeader;